export default function setTokenFromURL() {
  /**
   * setTokenFromURL - Extracts token and refreshToken from URL parameters and stores them in localStorage
   */

  if (typeof window !== 'undefined' && window.location) {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const refreshToken = params.get('refreshToken');

    if (token) {
      let tokenDecoded;
      try {
        tokenDecoded = decodeURIComponent(token);
      } catch (error) {
        tokenDecoded = token;
      }
      localStorage.setItem('token', tokenDecoded);
    }

    if (refreshToken) {
      let refreshTokenDecoded;
      try {
        refreshTokenDecoded = decodeURIComponent(refreshToken);
      } catch (error) {
        refreshTokenDecoded = refreshToken;
      }
      localStorage.setItem('refreshToken', refreshTokenDecoded);
    }

    if (token || refreshToken) {
      // Clean the URL to remove sensitive information
      const url = new URL(window.location);
      url.searchParams.delete('token');
      url.searchParams.delete('refreshToken');
      window.history.replaceState({}, document.title, url.toString());
    }
  }
}
